import { Image } from "./image";

export const Gallery = (props) => {
  return (
    <section id="portfolio" className="text-center">
      <div className="container">
        <div className="section-title">
          <h2>Munkáim</h2>
          <p>
            Fedezze fel legfrissebb projektjeimet és szakmai munkáimat, amelyek tükrözik elkötelezettségemet és szakértelmemet.
          </p>
        </div>
        <div className="row">
          {props.data
            ? props.data.map((d, i) => (
              <div className="col-lg-4 col-md-4 col-sm-6" key={i}>
                <div>
                  <Image
                    key={`${d.title}-${i}`}
                    title={d.title}
                    image={d.image}
                  />
                </div>
              </div>
            ))
            : "Loading..."}
        </div>
      </div>
    </section>
  );
};
